import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getIdealVehiclesService, getNotificationListService } from '../services/notification-service';
import { TWO_HUNDRED_SUCCESS_CODE } from '../utils/app-common';
import { warningNotificationStyle } from '../common/notification';
import { IdleVehiclePayload, NotificationMeta, RouteDeviationPayload } from '../components/DashboardComponent/DriverDashboard/interface';



export type Notification = {
    id: string;
    title: string;
    body: string;
    read: boolean;
    timestamp: number;
    image?: string
    data?: any
};

type NotificationState = {
    notifications: Notification[];
    notificationHistory;
    notificationCount: number;
    notificationToken: string | null;
    addNotification: (notification: Omit<Notification, 'read' | 'timestamp'> & { id: string }) => void;
    markAsRead: (id: string) => void;
    clearNotifications: () => void;
    clearNotificationCount: () => void;
    setNotificationToken: (token: string | null) => void;
    setNotificationHistory: (history) => void;
    addNotificationToHistory: (notification: any) => void;
    clearAll: () => void;
    vehicleIdleHistoryMeta: NotificationMeta[],
    getIdleVehicles: (payload: IdleVehiclePayload) => Promise<void>,
    setNotificationStore: (property: string, value: any) => void,
    getNotificationList: (payload: RouteDeviationPayload) => void,
    notificationList: []
};


export const useNotificationStore = create<NotificationState>()(
    persist(
        (set, get) => ({
            notificationToken: null,
            notifications: [],
            notificationCount: 0,
            notificationHistory: [],
            vehicleIdleHistoryMeta: [],
            notificationList: [],
            setNotificationToken: (token) => set({ notificationToken: token }),
            setNotificationHistory: (history) => set({ notificationHistory: history }),
            addNotification: (notification) => {
                const newNotification: Notification = {
                    ...notification,
                    read: false,
                    timestamp: Date.now(),
                };
                set({ notifications: [newNotification, ...get().notifications], notificationCount: get().notificationCount + 1 });

            },
            addNotificationToHistory: (notification) => {
                set((state) => ({
                    notificationHistory: [notification, ...state.notificationHistory],
                }));
            },
            markAsRead: (id) => {
                set({
                    notifications: get().notifications.map((n) =>
                        n.id === id ? { ...n, read: true } : n
                    ),
                });
            },
            setNotificationStore: (property: string, value: any) => {
                set({ [property]: value });
            },
            clearNotifications: () => set({ notifications: [] }),
            clearNotificationCount: () => set({ notificationCount: 0 }),
            clearAll: () => set({ notifications: [], notificationCount: 0, notificationToken: null }),
            getIdleVehicles: async (payload: IdleVehiclePayload) => {
                const response = await getIdealVehiclesService(payload);
                if (response?.status === TWO_HUNDRED_SUCCESS_CODE && Number(response?.data?.statusCode) === TWO_HUNDRED_SUCCESS_CODE) {
                    const list = response?.data?.data;
                    set({ vehicleIdleHistoryMeta: list ?? [] });
                    (!list || list?.length === 0) && warningNotificationStyle("No data found");
                };
            },
            getNotificationList: async (payload: RouteDeviationPayload) => {
                const response = await getNotificationListService(payload);
                const list = response?.data?.content;
                set({ notificationList: list ?? [] });
                (!list! || list?.length === 0) && warningNotificationStyle("No data found");
            },
        }),
        {
            name: 'notification-storage', // key in localStorage
            getStorage: () => sessionStorage, // use sessionStorage instead of localStorage
        }
    )
);
